import React from 'react';
import { HomeThreeTruths } from './HomeThreeTruths';
export function Home() {
  return <HomeThreeTruths data-id="element-723" />;
}